module.exports = __webpack_public_path__ + "assets/img/8415a21c89d7dffd415f7ed98a10d722.svg";